import { Modal } from '@ywwwtseng/react-kit';
import { CircleQuestionMark } from 'lucide-react';
import { Typography } from '@ywwwtseng/tma-react-kit';

const example = `{
  "data": {
    "level": {
      "gt": 99
    },
    "status": {
      "eq": "active"
    },
    "is_blacklist": {
      "eq": false
    }
  }
}`;

const example_headers = `X-API-KEY: 1234567890
X-API-TIMESTAMP: 1698765432
X-API-NONCE: 987654
X-API-SIGNATURE: 5d41402abc4b2a76b9719d911017c592...
`;

const user_info_example = `{
  "data": {
    "level": 100,
    "status": "active",
    "is_blacklist": false
  }
}`;

export function TaskGiftApiGuide() {
  return (
    <Modal
      title="claim type api guide"
      trigger={<CircleQuestionMark className="w-4 h-4" />}
    >
      <Typography size="3" i18n="claim_type_api_guide.title" />

      <div className="flex flex-col w-full gap-1 px-4 pb-4 max-h-[80vh] overflow-y-auto">
        <Typography
          size="1"
          dangerouslySetInnerHTML
          i18n="claim_type_api_guide.description"
          className="text-foreground/70 pb-1 [&_b]:text-white/80"
        />
        <Typography size="1" className="text-foreground/70">
          GET [api_url]
        </Typography>
        <Typography size="1" className="text-foreground/70">
          Headers
        </Typography>
        <Typography
          size="1"
          className="text-foreground/70 w-full card text-xs whitespace-pre-wrap"
        >
          {example_headers}
        </Typography>
        <Typography
          size="1"
          i18n="claim_type_api_guide.return_example_label"
          className="text-foreground/70"
        />
        <div className="w-full min-h-[150px] overflow-y-auto">
          <Typography
            size="1"
            className="w-full card text-xs whitespace-pre-wrap"
          >
            {example}
          </Typography>
        </div>
        <Typography size="1" className="text-foreground/70 mt-2">
          GET [api_url]?user_id=[user_id]
        </Typography>
        <Typography size="1" className="text-foreground/70">
          Headers
        </Typography>
        <Typography
          size="1"
          className="text-foreground/70 w-full card text-xs whitespace-pre-wrap"
        >
          {example_headers}
        </Typography>
        <Typography
          size="1"
          i18n="claim_type_api_guide.return_example_label"
          className="text-foreground/70"
        />
        <div className="w-full min-h-[150px] overflow-y-auto">
          <Typography
            size="1"
            className="w-full card text-xs whitespace-pre-wrap"
          >
            {user_info_example}
          </Typography>
        </div>
        <Typography
          size="1"
          className="text-foreground/70"
          i18n="claim_type_api_guide.upon_verification_desc"
        />
      </div>
    </Modal>
  );
}
